export const STRING = {
  MINUS: "-",
  DASH: "_",
  SPACE: " ",
} as const;
